export default class Accordion {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".accordion");
		this.triggers = this.el.querySelectorAll(".accordion__trigger");
		this.items = this.el.querySelectorAll(".accordion__item");
		this.itemSelector = ".accordion__item";
		this.contentSelector = ".accordion__content";
		this.contentInnerSelector = ".accordion__content-inner";
		this.expandedClass = "accordion__item--expanded";
		this.triggerAll = this.el.querySelector(".accordion__toggle");
		this.expandedAllClass = "accordion__toggle--expanded";
		this.expandItem = this.el.querySelector(".accordion__toggle-header");
		//expose accordionComponent on element
		utilities.dataStorage.put(this.el, "component", this);
		this.init();
	}
	init() {
		const self = this;
		this.attachEvents();
		this.checkHash();
	}
	checkHash() {
		const self = this;
		let hash = window.location.hash;

		if (hash == "#accordion-all") {
			this.expandAll();
		} else {
			if (hash) {
				hash = decodeURI(hash);
				const elementMatch = this.el.querySelector(hash);

				if (elementMatch) {
					// open when image exists in accordion and is loaded.
					self.expandAccordionItem(elementMatch);
				}
			}
		}
	}
	attachEvents() {
		const self = this;
		this.triggers.forEach(trigger => {
			trigger.addEventListener("click", function() {
				self.toggleAccordionItem(trigger.parentElement.parentElement);
			});
		});
		this.triggerAll.addEventListener("click", () => {
			this.toggleAll();
		});
		utilities.emitter.on("responsive/resize", size => {
			const currentItem = this.el.querySelector("." + this.expandedClass);
			if (currentItem) {
				setTimeout(function() {
					self.expandAccordionItem(currentItem, false, false);
				}, 100);
			}
		});
	}
	toggleAll() {
		if (this.triggerAll.classList.contains(this.expandedAllClass)) {
			this.collapseAll();
		} else {
			this.expandAll();
		}
	}
	toggleAccordionItem(accordionItem) {
		if (accordionItem.classList.contains(this.expandedClass)) {
			this.collapseAccordionItem(accordionItem);
		} else {
			this.expandAccordionItem(accordionItem);
		}
	}
	expandAccordionItem(accordionItem, setHash = true) {
		const self = this;
		const accordionContent = accordionItem.querySelector(
			this.contentSelector
		);
		accordionContent.classList.remove("hidden");
		utilities.setAriaProp(accordionContent, "hidden", false);

		const accordionContentInner = accordionItem.querySelector(
			this.contentInnerSelector
		);
		const waitForImage = accordionItem.querySelector("img.lazyload");
		if (waitForImage) {
			utilities.emitter.on("image/loaded", function(el) {
				if (accordionItem.contains(el)) {
					expand();
				}
			});
		} else {
			expand();
		}
		function expand() {
			accordionContent.style.height =
				accordionContentInner.scrollHeight + 10 + "px";
			accordionItem.classList.add(self.expandedClass);
			accordionItem
				.querySelector(".accordion__trigger")
				.setAttribute("aria-expanded", "true");
			if (setHash) {
				utilities.setHashUrl(accordionItem.getAttribute("id"));
			}
		}
	}
	collapseAccordionItem(accordionItem) {
		const accordionContent = accordionItem.querySelector(
			this.contentSelector
		);
		setTimeout(() => {
			// add delay beacuse of animation
			accordionContent.classList.add("hidden");
		}, 450);
		utilities.setAriaProp(accordionContent, "hidden", true);
		accordionContent.style.height = "0px";
		accordionItem.classList.remove(this.expandedClass);
		accordionItem
			.querySelector(".accordion__trigger")
			.setAttribute("aria-expanded", "false");
		utilities.resetHashUrl();
	}
	collapseAll() {
		this.items.forEach(element => {
			this.collapseAccordionItem(element);
		});
		utilities.setAriaProp(
			this.triggerAll.querySelector("button"),
			"expanded",
			false
		);
		utilities.setAriaProp(
			this.expandItem,
			"label",
			this.expandItem.querySelector(".accordion__toggle--open")
				.textContent
		);
		this.triggerAll.classList.remove(this.expandedAllClass);
		utilities.resetHashUrl();
	}
	updateHeight() {
		self.expandAccordionItem(currentItem);
	}
	expandAll() {
		const self = this;
		this.items.forEach(element => {
			self.expandAccordionItem(element, false);
		});
		utilities.setAriaProp(
			this.triggerAll.querySelector("button"),
			"expanded",
			true
		);
		utilities.setAriaProp(
			this.expandItem,
			"label",
			this.expandItem.querySelector(".accordion__toggle--close")
				.textContent
		);
		this.triggerAll.classList.add(this.expandedAllClass);
		utilities.setHashUrl(this.triggerAll.getAttribute("id"));
	}
}
